import { Component } from '@angular/core';
import { SharedModule } from '@Shared/shared.module';
import {  RoutingService } from './services';

@Component({
    selector: 'app-not-found',
    host: { 'class': 'content' },
    templateUrl: './not-found.component.html',
    styleUrls: [],
    imports: [SharedModule]
})
export class NotFoundComponent {

    constructor(public routingService: RoutingService
    ) {
    }

    goHome(){
        this.routingService.navigateToDefault();
    }
}
